import React from 'react';
import Header from '../Header';
import { Grid, Informations, MarcaAgua } from './styles';
import { Outlet } from 'react-router-dom';
import marcaAgua from '../../assets/logotipo-conforce.png';

export default function GridDashboard() {
  return (
    <Grid>
      <Header />
      <Informations>
        <Outlet />
      </Informations>
      <MarcaAgua alt="" src={marcaAgua} />
    </Grid>
  );
}
